module.exports = __webpack_public_path__ + "static/media/foto4.d88e0f0c.png";